import React from "react"
import { Link, Outlet, useLocation } from "react-router-dom"

const tabs = [
  { path: "/employer/messages/individual", label: "Individual messages" },
  { path: "/employer/messages/general", label: "General broadcasts" }
]

const EmployerMessagesLayout = () => {
  const location = useLocation()

  return (
    <div className="mx-auto max-w-6xl px-3 sm:px-0">
      <div className="mb-4 rounded-lg border border-gray-200 bg-white p-4 shadow-sm">
        <h2 className="text-lg font-semibold text-gray-900 sm:text-2xl">Messaging</h2>
        <p className="mt-1 text-sm text-gray-600">
          Send updates to individual candidates or broadcast a general message to all applicants on a job (in-app and by email).
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          {tabs.map((tab) => {
            const active = location.pathname === tab.path
            return (
              <Link
                key={tab.path}
                to={tab.path}
                className={`rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
                  active
                    ? "bg-black text-white"
                    : "border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
                }`}
              >
                {tab.label}
              </Link>
            )
          })}
        </div>
      </div>
      <Outlet />
    </div>
  )
}

export default EmployerMessagesLayout
